<template>
    <div id="user-detail-wrapper">
        <div id="user-detail-container">
            <div class="container-lg">
                <list-breadcrumb :breadcrumbs="breadcrumbs"></list-breadcrumb>

                <div class="user-detail-image">
                    <img :src="p_user.img"/>
                </div>

                <div class="user-detail-container">
                    <div class="user-detail-main">
                        <div class="user-detail-content">
                            <div class="title">{{ p_user.name }} <span v-if="p_user.is_identify_confirmed">✅<span class="small-txt">（本人情報確認済み）</span></span></div>
                            <div class="user-detail-rating-container">
                                <p class="rating">
                                    <i class="icon-good"></i><label>良かった（<a :href="p_user.reviewsUrl" class="user-detail-content-link">{{ p_user.goodCount }}</a>）</label>
                                    <i class="icon-bad"></i><label>残念だった（<a :href="p_user.reviewsUrl" class="user-detail-content-link">{{ p_user.badCount }}</a>）</label>
                                </p>
                            </div>
                            <div class="status">
                                <span>{{ p_user.itemsCount }}</span> 出品数　｜　<span>{{ p_user.followerCount }}</span>
                                フォロワー　｜　<span>{{ p_user.followCount }}</span> フォロー中
                            </div>
                        </div>
                        <div class="user-detail-actions">

                            <a href="javascript:void(0)" @click="followUser" class="user-detail-seller-follower-button"
                               v-if="p_user.following == false">
                                <i></i>
                                ＋フォローする
                            </a>

                            <a href="javascript:void(0)" @click="followUser" class="user-detail-seller-follower-button"
                               v-if="p_user.following">
                                <i></i>
                                ＋フォロー済み
                            </a>

                            <a href="javascript:void(0)" @click="messageUser" class="user-detail-seller-message-button">
                                メッセージ送信
                            </a>

                            <a href="javascript:void(0)" @click="toggleMoreActions" class="user-detail-seller-more-actions"
                            v-bind:class="{'selected': displayMoreActions}">
                                <i></i>
                            </a>

                            <section class="user-detail-more-actions" v-if="displayMoreActions" v-click-outside="toggleMoreActions">
                                <ul class="user-detail-more-actions_inner">
                                    <li>
                                        <a href="javascript:void(0)" @click="reportUser">このユーザーを報告する</a>
                                    </li>
                                </ul>
                            </section>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="user-detail mt-4">
                        <dl>
                            <dt>成人・未成年</dt>
                            <dd>{{p_user.is_adult ? '成人' : '未成年'}}</dd>
                        </dl>
                        <dl>
                            <dt>性別</dt>
                            <dd>{{p_user.gender == 'male' ? '男性' : '女性'}}</dd>
                        </dl>
                    </div>
                    <div class="user-detail-on">

                        <div class="user-detail-seller-desc"
                             v-bind:class="{'user-detail-seller-minimize-desc' : detailSellerDescriptionMin}"
                             ref="detail_seller_desc" v-html="p_user.comment"></div>

                        <div style="text-align: center"
                             v-if="havingSellerDescriptionMin && detailSellerDescriptionMin && p_user.comment">
                                <span class="user-detail-seller-desc-more-link">
                                    <a href="javascript:void(0)" @click="openSellerDescription">続きを読む</a>
                                    <span class="user-more-link-icon"></span>
                                </span>
                        </div>

                        <div style="text-align: center"
                             v-if="havingSellerDescriptionMin && detailSellerDescriptionMin == false && p_user.comment">
                                <span class="user-detail-seller-desc-more-link">
                                    <a href="javascript:void(0)" @click="closeSellerDescription">隠す</a>
                                    <span class="user-less-link-icon"></span>
                                </span>
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <div class="detail-relation-container">
            <div class="container-relation" ref="list_page_wrapper">
                <div class="container-inner-relation" :style="{ width: suggestWidth + 'px' }">
                    <div class="detail-section-item">
                        <h2>
                            このユーザーの新着商品
                            <span class="detail-section-item-link"><a :href="p_user.productUrl1">もっと見る</a></span>
                        </h2>

                        <div class="product-items-container">
                            <product-item v-for="(n_product, index) in n_products" :item="n_product" :key="index"
                                          v-if="index < itemsDisplay"></product-item>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-relation-container even">
            <div class="container-relation">
                <div class="container-inner-relation" :style="{ width: suggestWidth + 'px' }">
                    <div class="detail-section-item">
                        <h2>
                            このユーザーの人気商品
                            <span class="detail-section-item-link"><a :href="p_user.productUrl2">もっと見る</a></span>
                        </h2>
                        <div class="product-items-container">
                            <product-item v-for="(s_product, index) in s_products" :item="s_product" :key="index"
                                          v-if="index < itemsDisplay"></product-item>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        props: ['breadcrumbs', 'user', 'newproducts', 'sellerproducts'],
        data() {
            return {
                suggestWidth: null,
                detailMainImageHeight: null,
                detailSubImageWidth: null,
                detailSubImageHeight: null,
                p_user: JSON.parse(this.user),
                n_products: JSON.parse(this.newproducts),
                s_products: JSON.parse(this.sellerproducts),
                detailSellerDescriptionMin: false,
                havingSellerDescriptionMin: false,
                commentRating: 0,
                itemsDisplay: 0,
                commentText: '',
                windowWidth: 0,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                displayMoreActions: false,
            }
        },
        mounted() {
            this.handleResize();

        },
        methods: {
            toggleMoreActions() {
                this.displayMoreActions = !this.displayMoreActions;
            },
            openSellerDescription() {
                this.detailSellerDescriptionMin = false;
            },
            closeSellerDescription() {
                this.detailSellerDescriptionMin = true;
            },
            handleResize() {

                if (this.$refs.detail_seller_desc && (window.innerWidth != this.windowWidth)) {
                    this.windowWidth = window.innerWidth;
                    this.openSellerDescription();
                    let detail_seller_desc_height = this.$refs.detail_seller_desc.scrollHeight;
                    if (detail_seller_desc_height > 55) {
                        this.detailSellerDescriptionMin = true;
                        this.havingSellerDescriptionMin = true;
                    } else {
                        this.detailSellerDescriptionMin = false;
                        this.havingSellerDescriptionMin = false;
                    }
                }

                let window_width = window.innerWidth;
                if (this.$refs.list_page_wrapper) {
                    if (window_width >= 768) {
                        let wrapper_width = this.$refs.list_page_wrapper.clientWidth;

                        let iWidth = 210;
                        let suggestWidth = iWidth;
                        for (var i = 1; i < 100; i++) {
                            iWidth = 195 * i + 210;
                            if (iWidth > wrapper_width) break;
                            suggestWidth = iWidth;
                        }
                        this.suggestWidth = suggestWidth;
                        this.itemsDisplay = i;

                    } else {
                        let wrapper_width = this.$refs.list_page_wrapper.clientWidth;
                        this.suggestWidth = wrapper_width;
                        this.itemsDisplay = 2;
                    }
                }


            },
            reportUser() {
                if (this.p_user.user_id == this.p_user.id) {
                    return alert('自分を報告できません。');
                } else {
                    location.href = this.p_user.reportUrl;
                }
            },
            followUser() {
                let data = {};
                data.user_id = this.p_user.user_id;
                data.follow_user_id = this.p_user.id;
                axios.post('/item/follow', data)
                    .then(response => {
                        let status = response.data.status;
                        if (status == 0) {
                            alert('フォローしました。');
                            this.p_user.following = true;
                        } else if (status == -1) {
                            alert('自分をフォローできません。');
                        } else if (status == -2) {
                            alert('フォローするためにはログインが必要です。');
                        } else if (status == -3) {
                            alert('フォロー解除しました。');
                            this.p_user.following = false;
                        }
                    })
            },
            messageUser() {
                // if (this.p_user.user_id == 0) {
                //     alert('自分にはメッセージを送信できません。');
                // } else

                if (this.p_user.user_id == this.p_user.id) {
                    alert('自分にはメッセージを送信できません。');
                } else {
                    location.href = this.p_user.newMessageUrl;
                }
            },
            // twitterOpen() {
            //     window.open(this.p_item.twitterUrl, this.p_item.twitterSetting, 0);
            // },

        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
    }
</script>

<style lang="scss" scoped>

    #user-detail-container {
        padding-top: 60px;
        padding-bottom: 40px;
    }

    @media (max-width: 768px) {
        #user-detail-container {
            padding-top: 20px;
        }
    }

    .user-detail-image {
        float: left;
        width: 160px;
        padding-right: 30px;
    }

    .user-detail-image img {
        width: 100%;
        height: 130px;
        object-fit: cover;
        border-radius: 50%;
    }

    .user-detail-container {
        width: calc(100% - 160px);
        display: inline-block;
    }

    .user-detail-content {
        float: left;
    }

    .user-detail-actions {
        float: right;
        position: relative;
    }

    .user-detail {
        dl {
            display: flex;
            margin-bottom: 0;
            margin-top: 0.5rem;
            dt {
                width: 100px;
                border-right: 1px solid #333333;
                padding-bottom: 0;
                margin-bottom: 0;
                font-weight: normal;
            }
            dd {
                font-weight: bold;
                margin-left: 1rem;
                padding-bottom: 0;
                margin-bottom: 0;
            }
        }
    }


    @media (max-width: 600px) {
        .user-detail-image {
            float: none;
            margin: auto;
            margin-bottom: 20px;
            padding-right: 0;
        }

        .user-detail-image img {
            height: 160px;
        }

        .user-detail-container {
            width: 100%;
        }

        .user-detail-content {
            float: none;
        }

        .user-detail-actions {
            float: none;
            margin-top: 20px;
            text-align: center;
        }
    }

    .user-detail-description {
        margin-top: 40px;
    }

    .user-detail-content .title {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 16px;
    }

    .user-detail-content .status {
        margin-top: 20px;
        font-size: 13px;
    }

    .user-detail-content .status span {
        font-weight: bold;
    }

    .user-detail-content-link {
        font-size: 15px;
        color: #666666;
        text-decoration: underline;
    }

    .user-detail-content-link:hover {
        text-decoration: none;
        color: #666666;
    }

    .user-detail-content-link:visited {
        color: #666666;
    }

    .user-detail-seller-desc {
        color: #333333;
        font-size: 13px;
        padding: 0 6px;
        line-height: 18px;
        margin-bottom: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        /*white-space: pre;*/
        margin-top: 30px;
    }

    .user-detail-seller-minimize-desc {
        height: 54px;
        -webkit-line-clamp: 3;
    }

    .user-detail-seller-desc-more-link {
        text-align: center;
        position: relative;
        padding-right: 18px;
    }

    .user-detail-seller-desc-more-link a, .user-detail-seller-desc-more-link a:hover, .user-detail-seller-desc-more-link a:visited {
        color: #333333;
        text-decoration: none;
    }

    .user-more-link-icon {
        display: block;
        position: absolute;
        top: 7px;
        right: 0;
        bottom: 0;
        width: 8px;
        height: 8px;
        border-right: 2px solid #363636;
        border-bottom: 2px solid #363636;
        transform: translateY(-2px) rotate(45deg);
        transition: transform 0.2s ease;
    }

    .user-less-link-icon {
        display: block;
        position: absolute;
        top: 11px;
        right: 0;
        bottom: 0;
        width: 8px;
        height: 8px;
        border-right: 2px solid #363636;
        border-bottom: 2px solid #363636;
        transform: translateY(-2px) rotate(-135deg);
        transition: transform 0.2s ease;
    }


    .user-detail-seller-follower-button {
        /*margin-top: 12px;*/
        font-size: 13px;
        color: #333333;
        line-height: 17px;
        padding-top: 11px;
        padding-bottom: 11px;
        background-color: #ffffff;
        border: 1px solid #B3B3B3;
        border-radius: 30px;
        /*width: 100%;*/
        display: inline-block;
        text-align: center;
        min-width: 140px;
    }

    .user-detail-seller-follower-button:hover {
        color: #333333;
        opacity: 0.5; text-decoration: none;
    }

    .user-detail-seller-follower-button:visited {
        color: #333333;
    }

    .user-detail-seller-follower-button i {
        background-image: url("/images/icons/user.svg");
        width: 15px;
        height: 15px;
        display: inline-block;
        vertical-align: sub;
        background-repeat: no-repeat;
    }

    .user-detail-seller-message-button {
        /*margin-top: 12px;*/
        font-size: 13px;
        color: #333333;
        line-height: 17px;
        padding-top: 11px;
        padding-bottom: 11px;
        background-color: #ffffff;
        border: 1px solid #B3B3B3;
        border-radius: 30px;
        /*width: 100%;*/
        display: inline-block;
        text-align: center;
        min-width: 140px;
    }
    .user-detail-seller-message-button:hover {
        color: #333333;
        opacity: 0.5; text-decoration: none;
    }

    .user-detail-more-actions {
        z-index: 9999;
        top:45px; right: 0;
        position: absolute;
    }

    .user-detail-more-actions_inner {
        background-color: #fff;
        box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 10%);
        text-align: left;
        white-space: normal;
        padding-inline-start: 0;
    }

    .user-detail-more-actions_inner a:hover {
        text-decoration: none;
    }

    .user-detail-more-actions ul li {
        list-style: none;
        position: relative;
    }

    .user-detail-more-actions a {
        padding: 12px 18px;
        display: block;
        font-size: 13px;
        color: #363636;
        border: none;
        width: 100%;
        text-align: left;
        white-space: nowrap;
        background: #fff;
        cursor: pointer;
    }

    .user-detail-more-actions a:hover {
        background-color: #F3F3F3;
        /*color: white !important;*/
    }

    .user-detail-seller-more-actions {
        background-color: #ffffff;
        border: 1px solid #B3B3B3;
        border-radius: 30px;
        height: 40px;
        width: 40px;
        display: inline-block;
        vertical-align: middle;
    }

    .user-detail-seller-more-actions:hover {
        opacity: 0.5;
    }

    .user-detail-seller-more-actions.selected {
        background-color: #F3F3F3;
    }

    .user-detail-seller-more-actions i {
        background-image: url(/images/icons/more.svg);
        width: 38px;
        height: 38px;
        background-repeat: no-repeat;
        background-size: 18px 18px;
        display: inline-block;
        background-position: center center;
    }
</style>